import { Injectable } from '@angular/core';
import { UserInfo } from './user-info.model';
import { CryptoService } from 'src/app/shared/crypto/crypto.service';
import { GeneralHttpService } from 'src/app/shared/general-http.service';

@Injectable({
  providedIn: 'root'
})
export class InfoUserService {
  infoUser: UserInfo;
  private routeApi = "SegModulos";
  constructor(
    private _generalHttp: GeneralHttpService,
    private encryptService: CryptoService,
  ) { }

  getUserInfo() {
    let temp = sessionStorage.getItem('userInfo');
    let item = this.encryptService.decrypt(temp);
    this.infoUser = JSON.parse(item) as UserInfo;
  }

  getMenuModules(idUsuario, idEmpresa) {
    //debugger
    let form = {
      idUsuario: this.encryptService.encryptToSend(idUsuario.toString()),
      idEmpresa: this.encryptService.encryptToSend(idEmpresa.toString())
    }
    return this._generalHttp.postHttp(form, `${this.routeApi}/GetMenuModulos`);
  }


  setDataUser(dataUser: any) {
    this.infoUser = dataUser;
  }

  async getDataUser() {
    //debugger;
    if (sessionStorage.getItem("userInfo") != null) {
      let tempData = sessionStorage.getItem("userInfo");
      let item = this.encryptService.decrypt(tempData);
      let dataForUser = JSON.parse(item) as UserInfo;
      this.setDataUser(dataForUser);
    }
    return (typeof (this.infoUser) === 'undefined') ? null : this.infoUser;
  }

  remove() {
    this.infoUser = null;
  }
}
